import React, { useRef } from 'react';
import DataGrid, { Button, Column, Editing, Form, Popup } from "devextreme-react/data-grid";
import { dataGridErrorHandling } from '../../utils/errorHandling';
import { GroupItem, Item } from "devextreme-react/form";
import { useDeambulazioneTipiDataSource } from '../../datasources/DeambulazioneTipiDataSource';
import { useTipiContattiDataSource } from '../../datasources/TipiContattiDataSource';

type Props = {
  onchanged?: () => void;
}

export type TipiContattiPanelHandle = {}

const TipiContattiPanel: React.ForwardRefRenderFunction<TipiContattiPanelHandle> = (props, ref) => {
  const dataSource = useTipiContattiDataSource();
  const gridRef = useRef(null);

  return (
    <React.Fragment>
      <DataGrid
        dataSource={dataSource}
        ref={gridRef}
        onDataErrorOccurred={dataGridErrorHandling}
        onRowUpdating={e => e.newData = Object.assign({}, e.oldData, e.newData)}
      >
        <Editing
          mode="popup"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={true}>
          <Popup title="Tipo di contatto" showTitle={true} />
          <Form colCount={1}>
            <Item dataField="descrizione" editorType='dxTextBox' />
          </Form>
        </Editing>
        <Column type='buttons' alignment='left'/>
        <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
        <Column dataField={'descrizione'} caption={'Descrizione'} />
      </DataGrid>
    </React.Fragment>
  );
}

export default React.forwardRef(TipiContattiPanel);
